import styled from "@emotion/styled";
import ProposalForm from "../../pages/suppliers/customer-service/proposal-form";

export const Steps = styled.ul`
  position: relative;
  overflow: hidden;
  &::before {
    content: " ";
    border-width: 0;
    border-style: dashed;
    border-color: #e6e6e7;
    height: 95%;
    position: absolute;
    border-left-width: 2px;
    z-index: -1;
    left: 12px;
    top: 10px;
  }

  li {
    margin-bottom: 26px;
    display: flex;
    align-items: center;
    gap: 10px;
    span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      background: #b9babc;
      border: 2px solid #e6e6e7;
      border-radius: 50%;
      color: #f2f9f1;
      padding-top: ${({ locale }) => (locale ? "2px" : "0")};
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  li.active {
    color: #17479e;
    font-weight: 700;
    span {
      background: #17479e;
    }
  }
  li.passed {
    span {
      background: #6dc067;
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      display: "grid",
      gridAutoColumns: "165px",
      gridAutoFlow: "column",
      overflowX: "auto",
      borderBottom: "1px solid #E6E6E7",
      cursor: "grab",
      "::-webkit-scrollbar": { width: "0", background: "transparent" },
      "::-webkit-scrollbar-thumb": { background: "#FFF" },
      "&::before": {
        display: "none",
      },

      li: { marginBottom: 20, "&:last-of-type": { marginBottom: 20 } },
    },
  })};
`;

export const SatisfactionEthylenePage = styled.div`
  .inputWrapper {
    margin-bottom: 30px;
  }
  .consumption {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .inputWrapper {
      margin-bottom: 0;
    }
    span {
      margin-inline: 20px;
    }
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      "& .consumption": {
        justifyContent: "center",
        ".inputWrapper": {
          width: "100%",
          ".MuiFormControl-root": {
            width: "100%",
          },
        },
      },
    },
  })};
`;

export const ProposalFormPage = styled.div`
  .inputWrapper {
    margin-bottom: 30px;
  }
  .filesInputWrapper {
    p {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 20px;
    }
  }
`;

export const CustomerComplaintFormPage = styled.div`
position: relative;
  max-width: 800px;
  margin: 0 auto;
  .inputWrapper {
    margin-bottom: 30px;
  }
`;

export const GuidSection = styled.div`
  border-bottom: 1px solid #f2f2f3;
  padding-bottom: 30px;
  margin-bottom: 30px;
  height: auto;
  max-height: 45px;
  overflow: hidden;
  transition: all 250ms ease-in-out;
  &.open {
    max-height: 300px;
    .headLine {
      i {
        svg {
          transform: rotate(0deg);
        }
      }
    }
  }
  .headLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f2f2f3;
    p {
      font-weight: 700;
      font-size: 16px;
      color: #000000;
    }
    i {
      padding: 5px 10px;
      cursor: pointer;
      svg {
        transform: rotate(180deg);
        transition: all 250ms ease-in-out;
      }
    }
  }
  ul {
    display: flex;
    align-items: center;
    flex-flow: wrap;
    justify-content: space-between;
    li {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      color: #000000;
      min-width: 350px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      i {
        margin-right: 10px;
        width: 28px;
        height: 28px;
        border: 1px solid #e6e6e7;
        background: #ffffff;
        border-radius: 8px;
        line-height: 24px;
        font-style: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          padding: 2px 12px;
          font-weight: 400;
          font-size: 14px;
          text-align: center;
          text-transform: lowercase;
          color: #000000;
        }
      }
    }
  }
`;

export const GuidStatus = styled.div`
  display: flex;
  align-items: center;
  background: #e9ecf5;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 30px;
  i {
    display: flex;
    margin-right: 8px;
  }
  p {
    font-weight: 500;
    font-size: 13px;
    line-height: 22px;
    color: #17479e;
  }
`;

export const PAsTitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
  margin-bottom: 20px;
  text-transform: capitalize;
`;

export const ScoresWrapper = styled.div`
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  column-gap: 80px;
  .inputWrapper {
    margin-bottom: 0;
    flex: 1 0 auto;
  }
`;

export const LastOpinion = styled.p`
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  color: #000000;
`;

export const RegistrationFormPage = styled.div`
  max-width: 800px;
  margin: 0 auto;
  .download {
    display: flex;
    align-items: center;
    column-gap: 16px;
    padding: 12px 23px;
    border: 1px solid #000000;
    border-radius: 8px;
    max-width: fit-content;

    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #000000;
    i {
      display: flex;
    }
  }
  button {
    text-transform: capitalize;
  }
`;
